import _ from 'lodash';
import React from 'react';

import {
  Header,
} from '@mairistem/composants';
import {
  CalendarView,
  Density,
  Interval,
  Planning as PlanningJvs,
  ResourceContainer,
  ResourceGroup,
  View,
} from '@mairistem/planning';

import { Creneau } from './Creneau';
import PlanningHeader from './PlanningHeader';

import { Mode, Planning as PlanningConsts } from '../const';
import { PlanningContext } from '../context';

const Planning = () => {
  const {
    view,
    viewHandlers: { changeToView },
    mode,
    currentDate,
    dateHandlers: {
      goBackward,
      goForward,
      goTo,
    },
    reservationsOfView,
    reservationHandlers: {
      create: createReservation,
    },
    selectedSalles,
  } = React.useContext(PlanningContext);

  return (
    <>
      <PlanningHeader
        onViewChange={changeToView}
        onDateChange={goTo}
        onNextDateClick={goForward}
        onPreviousDateClick={goBackward}
        view={view}
        date={currentDate}
      />
      {mode === Mode.HORIZONTAL && (
        <div // Gère la taille fixe (avec scroll interne) du planning
          style={{
            display: 'flex', // pour que le planning s'étire au max en hauteur
            flexDirection: 'column', // pour que le planning s'étire au max en largeur
            paddingRight: PlanningConsts.SCROLLBAR_WIDTH,
            ...!_.isEmpty(selectedSalles) && { flex: 1 },
          }}
        >
          <PlanningJvs
            width={12}
            currentDate={currentDate}
            events={reservationsOfView}
            headerDensity={Density.LIGHT}
            view={view}
            onHeaderClick={(mouseEvent, day) => goTo(day, true)}
            interval={
              view === View.DAY
                ? Interval.HALF_HOUR
                : view === View.WEEK
                  ? Interval.HALF_DAY
                  : Interval.DAY
            }
            innerscroll
            getRowHeight={() => PlanningConsts.ROW_HEIGHT}
            hover="cell"
            {...view === View.DAY && { weekendColor: 'black' }}
          >
            <CalendarView onClick={createReservation}>
              {(event) => (
                <Creneau
                  key={event.identifiant}
                  reservations={event.reservations}
                  partiel={event.partiel}
                  dateDebut={event.dateDebut}
                />
              )}
            </CalendarView>
            <ResourceContainer
              collapsible
              resources={selectedSalles}
              headers={[
                <div style={{ fontSize: '18px', padding: '3px 0 0 7px' }}>
                  Salles
                </div>,
              ]}
              getRowHeight={() => PlanningConsts.ROW_HEIGHT}
            >
              <ResourceGroup
                inverted
                property="libelleTypesSalle"
                collapsible
                style={{
                  color: 'black',
                  backgroundColor: '#c2d7f0',
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                }}
              />

              {(data) => (
                <div style={{ padding: '5px 0 0 20px' }}>
                  { data.nomSalle }
                </div>
              )}

            </ResourceContainer>
          </PlanningJvs>
        </div>
      )}
      {_.isEmpty(selectedSalles) && (
        <Header color="blue" as="h3" textAlign="center">
          Veuillez sélectionner au moins une salle
        </Header>
      )}
    </>
  );
};

export default Planning;
